import React, { Component } from 'react';
import { ConfirmationModal } from '../../components';
import s from './HostStyles.module.scss';

export default class ConfirmationModalEditor extends Component {
    constructor(props) {
        super(props);
        this.state = { modalOpen: false, lastResponse: '' };
    }

    openModal = () => {
        this.setState({ modalOpen: true });
    };

    closeModal = result => {
        const response = String(result);

        this.setState({ modalOpen: false, lastResponse: response });
    };

    render() {
        const { modalOpen, lastResponse } = this.state;

        return (
            <div className={s.editor}>
                <button type="button" onClick={this.openModal}>
                    Show Modal
                </button>
                {lastResponse && <div>The last response was: {lastResponse}</div>}
                <ConfirmationModal open={modalOpen} onClose={this.closeModal} />
            </div>
        );
    }
}
